import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { clearNotification } from 'store/notification.slice';

export const SnackBar = () => {
  const notification = useAppSelector((state) => state.notificationReducer);
  const dispatch = useAppDispatch();
  const handleClose = () => {
    dispatch(clearNotification());
  };
  const vertical = 'bottom';
  const horizontal = 'right';

  /*
    Close the snackbar automatically — errors get up to 5 secs since
    their messages tend to be longer, everything else closes after 3 secs
  */
  React.useEffect(() => {
    if (['longSuccess', 'longError'].includes(notification.type)) return;
    const duration = notification.type === 'error' ? 5000 : 3000;
    const timerId = setTimeout(() => {
      handleClose();
    }, duration);
    // Cleaning up timeout here to prevent memory leak
    return () => {
      clearTimeout(timerId);
    };
  }, [notification]);

  return (
    <Snackbar
      open={notification.show}
      anchorOrigin={{ vertical, horizontal }}
      key={vertical + horizontal}
    >
      <Alert
        onClose={handleClose}
        icon={false}
        variant="filled"
        severity={
          ['success', 'longSuccess'].includes(notification.type)
            ? 'success'
            : ['error', 'longError'].includes(notification.type)
            ? 'error'
            : notification.type === 'info'
            ? 'info'
            : 'warning'
        }
        sx={{
          width: '100%',
          letterSpacing: '0px',
          textAlign: 'left',
        }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};
